import { Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';

@Component({
  selector: 'app-confirm-user-account',
  templateUrl: './confirm-user-account.component.html',
  styleUrls: ['./confirm-user-account.component.scss'],
  standalone: false,
})
export class ConfirmUserAccountComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  private aroute = inject(ActivatedRoute);
  private toast = inject(ToastService);
  private translate = inject(TranslateService);

  status = signal<'pending' | 'success' | 'error'>('pending');
  message = signal<string>('EmailVerification.Confirming');

  ngOnInit() {
    const token = this.aroute.snapshot.queryParamMap.get('token');

    if (!token) {
      this.status.set('error');
      this.message.set('EmailVerification.Failed');
      return;
    }

    this.verifyToken(token);
  }

  async verifyToken(token: string) {
    try {
      this.status.set('pending');
      this.message.set('EmailVerification.Confirming');

      await this.authService.verifyEmailToken(token);

      this.status.set('success');
      this.message.set('EmailVerification.Confirmed');
      this.toast.snackbar.open(this.translate.instant('EmailVerification.ToastVerified'), 'Ok', { duration: 3000 });

      setTimeout(() => {
        this.router.navigate(['/login']);
      }, 3000);
    } catch (e) {
      console.error('Email verification token error:', e);
      this.status.set('error');
      this.message.set('EmailVerification.Failed');
      this.toast.snackbar.open(this.translate.instant('EmailVerification.ToastNotVerified'), 'Ok', { duration: 3000 });
    }
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}
